import { useState } from "react";
import BroadcastTimeSCP from "../../../../../../../Services/Data/SCP/BroadcastTimeSCP";
import BroadcastColorSCP from "../../../../../../../Services/Data/SCP/BroadcastColorSCP";
import ButtonGrid from "../../../../Components/ButtonGrid/ButtonGrid";
import { AddToastNotification } from "../../../../../../../Services/ToastNotification/ToastNotificationManager";
import ServerRequests from "../../../../../../../Services/Api/ServersRequests.ts";

const Broadcasting = ({serverId, getPlayerIds}) => {
    const serverRequests = new ServerRequests();

    const [selectedTime, setSelectedTime] = useState(-1);
    const [selectedColor, setSelectedColor] = useState(-1);

    const [bold, setBold] = useState(false);
    const [italic, setItalic] = useState(false);
    const [underline, setUnderline] = useState(false);
    const [strikethrough, setStrikethrough] = useState(false);

    const [message, setMessage] = useState("");

    const sendBroadcast = (prefix, checkPlayers) => {
        if(selectedTime == -1)
        {
            AddToastNotification("You must select the time before sending this broadcast!", 0);
            return;
        }

        if(checkPlayers && getPlayerIds().length <= 0)
        {
            AddToastNotification("Musisz wybrać graczy!", 0);
            return;
        }

        if(message.length <= 0)
        {
            AddToastNotification("Musisz uzupełnić wiadomość!", 0);
            return;
        }

        let messageToSend = message;

        if(bold)
            messageToSend = `<b>${messageToSend}`;

        if(italic)
            messageToSend = `<i>${messageToSend}`;       

        if(underline)
            messageToSend = `<u>${messageToSend}`;

        if(strikethrough)
            messageToSend = `<s>${messageToSend}`; 

        if(selectedColor != -1)
            messageToSend = `<color=${BroadcastColorSCP[selectedColor]?.style.color}>${messageToSend}`;

        serverRequests.ExecuteCommand(serverId, `/${prefix} ${BroadcastTimeSCP[selectedTime].time} ${messageToSend}`, () => {
            AddToastNotification("Polecenie wysłane do wykonania!", 1);
        })
    } 

    return (
        <>
            <h3 className="text-center">Write a message and it will appear at the top of the screen.</h3>
            <div className="flex mt-8">
                <div className="mr-16 ml-8">
                    <ButtonGrid className={"grid-cols-[repeat(6,4vw)]"} buttons={BroadcastTimeSCP} selected={selectedTime} setSelected={setSelectedTime}/>     
                    <div className="flex gap-2 mt-6 ml-2 mr-1">
                        <div className="remoteAdminButton w-[50%]">
                            Clear Input
                        </div>
                        <div className="remoteAdminButton w-[50%]">
                            Clear Broadcasts
                        </div>
                    </div>
                </div>
                <div>
                    <ButtonGrid className={"grid-cols-[repeat(4,4vw)]"} buttons={BroadcastColorSCP} selected={selectedColor} setSelected={setSelectedColor}/>

                    <div className="grid grid-cols-[repeat(4,4vw)] mt-5 gap-3">
                        <div onClick={() => setBold(!bold)} className={`textSquareButton font-extrabold ${bold ? "textSquareButtonSelected" : ""}`}>
                            <p title="bold" className="w-100p">B</p>
                        </div>
                        <div onClick={() => setItalic(!italic)} className={`textSquareButton italic ${italic ? "textSquareButtonSelected" : ""}`}>
                            <p title="Italic" className="w-100p">I</p>
                        </div>
                        <div onClick={() => setUnderline(!underline)} className={`textSquareButton underline ${underline ? "textSquareButtonSelected" : ""}`}>
                            <p title="Underline" className="w-100p">U</p>
                        </div>
                        <div onClick={() => setStrikethrough(!strikethrough)} className={`textSquareButton line-through ${strikethrough ? "textSquareButtonSelected" : ""}`}>
                            <p title="Strikethrough" className="w-100p">S</p>
                        </div>
                    </div>
                </div>

            </div>
            <div className="mt-12">
                <textarea value={message} onChange={(e) => setMessage(e.target.value)} className="mx-[5%] w-[90%] raTextArea" placeholder="Message..." rows={4}/>
            </div>
            <div className="mt-12 flex gap-[2%]">
                <div onClick={() => sendBroadcast(`pbc ${getPlayerIds()}`, true)} className="remoteAdminButton w-[49%]">
                    Send Privately
                </div>
                <div onClick={() => sendBroadcast("bc", false)} className="remoteAdminButton w-[49%]">
                    Send To All
                </div>
            </div>
        </>
    )
};

export default Broadcasting;